import { render } from '@wordpress/element';
import './index.css';
import "react-datepicker/dist/react-datepicker.css";

import App from "./components/App";

declare global {
    interface Window { pbc_facet_options: any; }
}

window.pbc_facet_options = window.pbc_facet_options || {};

render(
    <App wpProps={window.pbc_facet_options} />,
    document.getElementById("app")
); 